(() => {
  const positionViewers = () => {
    const description = document.querySelector('.product-block-list__wrapper > .product-block-list__item--description:not(.product-block-list__item--use):not(.product-block-list__item--titanium-3d):not(.product-block-list__item--ironclad-3d) .rte');
    if (!description) return;
    for (const id of ['elite-titanium-3d', 'elite-ironclad-3d']) {
      const viewer = document.getElementById(id);
      if (!viewer) continue;
      const rows = Array.from(description.querySelectorAll(id === 'elite-titanium-3d' ? '.tlp-row' : '.icx-row,.icx-power'));
      const cards = description.querySelector(id === 'elite-titanium-3d' ? '.tlp-row.tlp-cards' : '.icx-row.tlp-cards');
      const anchor = cards || rows[Math.floor(rows.length / 2)];
      const block = id === 'elite-titanium-3d' ? viewer.closest('.shopify-section') : viewer.closest('.product-block-list__item--ironclad-3d');
      if (!anchor || !block || block.contains(anchor)) continue;
      block.classList.add('elite-viewer-description-middle');
      if (block.nextElementSibling !== anchor) anchor.parentNode.insertBefore(block, anchor);
    }
  };
  const init = root => {
    positionViewers();
    const viewers = root.querySelectorAll('.elite-titanium-3d__model');
    for (const viewer of viewers) {
      if (viewer.dataset.initialized) continue;
      viewer.dataset.initialized = 'true';
      const stage = viewer.parentElement;
      const status = stage.querySelector('.elite-titanium-3d__status');
      viewer.addEventListener('load', () => { status.textContent = status.dataset.loaded; });
      viewer.addEventListener('error', () => { status.textContent = status.dataset.error; });
      stage.querySelector('button').addEventListener('click', () => {
        viewer.cameraOrbit = '0deg 90deg auto';
        viewer.cameraTarget = 'auto auto auto';
        viewer.fieldOfView = 'auto';
      });
      const load = () => {
        if (customElements.get('model-viewer') || document.querySelector('script[data-elite-model-viewer]')) return;
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
        script.dataset.eliteModelViewer = 'true';
        script.addEventListener('error', () => { status.textContent = status.dataset.error; });
        document.head.appendChild(script);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); }
        }, {rootMargin: '250px'});
        observer.observe(viewer);
      } else load();
    }
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

